export default __webpack_public_path__ + "static/media/BB_42.bf2aee78.png";